import {Button, ColourSolid, PricingBlock, PricingBlockEntry} from "@twigsby/frontend-framework";
import React from "react";
import {SignUpGenericSectionInterface} from "../../Types/SignUp/SignUpSection";
import {SignUpPlanType} from "../../Types/SignUp/SignUpPlan";
import {SignUpPerkType} from "../../Types/SignUp/SignUpPerk";
import SignUpSectionHeader from "./SignUpSectionHeader";

const SignUpGenericSection: React.FC<SignUpGenericSectionInterface> = (props) => {
    const HandleEditCallback = () => {
        if(props.onEditCallback) {
            props.onEditCallback();
        }
    }

    return (
        <div className={`sign-up-section ${props.visible ? 'mb-xxxl' : 'sign-up-section-hide'} ${props.complete && !props.visible ? 'sign-up-section-complete mt-xs' : 'mt-lg'}`}>
            <SignUpSectionHeader label={props.label} completeLabel={props.completeLabel} complete={props.complete} visible={props.visible} editCallBack={() => HandleEditCallback()} />

            {props.visible && (
                <div className={'flex-row flex-wrap flex-gap-sm plan-wrapper'}>

                    {props.plansOverview.map((plan: SignUpPlanType, index : number) => {
                        if (!plan.enabled) return null;

                        return (
                            <PricingBlock key={`${index}-${plan.id}`} title={plan.label} price={plan.cost} extraInfo={plan.labelExtra} variablePrice={plan.variablePrice} callBackContent={<SelectPlan parentProps={props} itemProps={plan} />}>
                                <div className={'pricing-block-entries'}>
                                    {props.planPerks.map((perk: SignUpPerkType, index: number) => {
                                        const included = plan.perks.includes(perk.id);

                                        if (!perk.enabled || props.hideExcluded && !included) return null;

                                        return (
                                            <PricingBlockEntry key={`${index}-${plan.id}-${perk.id}`} title={perk.label} markersFirst={true} noMarkers={props.hideMarks} included={included} showTip={plan.tips && plan.tips.includes(perk.id)}/>
                                        )
                                    })}
                                </div>
                            </PricingBlock>
                        )
                    })}

                </div>
            )}
        </div>
    );
};

export default SignUpGenericSection;

export type SelectPlanType = {
    itemProps: SignUpPlanType;
    parentProps: SignUpGenericSectionInterface;
}

export const SelectPlan = (props: SelectPlanType) => {
    const planSelected = props.parentProps.value === props.itemProps.id;

    const HandleCallBack = () => {
        if(props.parentProps.value === props.itemProps.id) {
            if(props.parentProps.onCancelCallback) {
                props.parentProps.onCancelCallback();
            }
        } else {
            if(props.parentProps.onChangeCallback) {
                props.parentProps.onChangeCallback(props.itemProps);
            }
        }
    }

    return (
        <Button title={planSelected ? 'Selected' : 'Select'} colour={planSelected ? ColourSolid.Selected : ColourSolid.Primary} fullWidth={true} onClick={() => HandleCallBack()} />
    )
}
